import { useId } from 'react';
import { useDispatch } from 'react-redux';
import { PrimaryButton } from 'ui/button';
import { ModalFooter, ModalBody, ModalHeader, Modal, MODAL_SIZES } from 'ui/modal';
import {
  AuthedEmailEditFormProvider,
  AuthedEmailEditFormContextType,
} from '../contexts/AuthedEmailEditFormProvider';
import { editSenderRequest } from '../actions';
import { AuthedEmailEditForm } from './AuthedEmailEditForm';
import type { AuthedEmailEditModalProps } from '../types';

export const AuthedEmailEditModal = ({ authedEmail, onClose }: AuthedEmailEditModalProps) => {
  const dispatch = useDispatch();
  const id = useId();
  const formId = useId();

  const onSubmit = (data: AuthedEmailEditFormContextType) => {
    dispatch(
      editSenderRequest({
        ...authedEmail,
        ...data,
      }),
    );
    onClose();
  };

  const defaultValues = {
    senderName: authedEmail.senderName,
    defaultReplyTo: authedEmail.defaultReplyTo,
  };

  return (
    <AuthedEmailEditFormProvider defaultValues={defaultValues}>
      <Modal size={MODAL_SIZES.SMALL} onClose={onClose} isModalOpen id={id}>
        <ModalHeader>Update sender</ModalHeader>
        <ModalBody>
          <AuthedEmailEditForm formId={formId} onSubmit={onSubmit} />
        </ModalBody>
        <ModalFooter onClose={onClose}>
          <PrimaryButton type="submit" form={formId} data-test="senders-edit-sender-action">
            Confirm
          </PrimaryButton>
        </ModalFooter>
      </Modal>
    </AuthedEmailEditFormProvider>
  );
};
